import { createApp } from "vue";
import { createI18n } from "vue3-i18n";
import App from "./App.vue";
import router from "./router";
import store from "@/store";
import swal from "./plugins/swal";
import axios from "axios";
import "@/services/axios/interceptors";
require("@/store/subscriber");
import Vue3FormWizard from "vue3-form-wizard";
import "vue3-form-wizard/dist/style.css";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { FontAwesomeIcon } from "./plugins/font-awesome";
import "vue-cal/dist/vuecal.css";

/*
Components
*/
/**
 * elements
 */
import LockScreen from "@/components/elements/LockScreen.vue";

import Modal from "@/components/elements/modal.vue";
import Tooltip from "@/components/elements/tooltip.vue";
import NotFound from "./components/elements/notfound.vue";
import goBack from "./components/elements/goBack.vue";
import Loader from "./components/elements/loader.vue";
import NoPermission from "./components/elements/NoPermission.vue";
import Paginate from "./components/elements/paginate.vue";
import Status from "./components/elements/status.vue";
import booleanStatus from "./components/elements/booleanStatus.vue";
import statusSubscription from "./components/elements/statusSubscription.vue";
import statusPayment from "./components/elements/statusPayment.vue";

import accesBlocked from "./components/elements/accesBlocked.vue";
import isPaid from "./components/elements/isPaid.vue";
import perPage from "./components/elements/perPage.vue";
import scannerQrCode from "./components/elements/scannerQrCode.vue";
import capturePhoto from "./components/elements/capturePhoto.vue";

import Delete from "@/components/buttons/Delete.vue";
import Edit from "@/components/buttons/Edit.vue";
import Default from "@/components/buttons/Default.vue";
import MonthField from "./components/inputsValidation/MonthField.vue";
import DateField from "./components/inputsValidation/DateField.vue";
import DateRangeField from "./components/inputsValidation/DateRangeField.vue";
import TimeRangeField from "./components/inputsValidation/TimeRangeField.vue";
import PhoneNumber from "./components/inputsValidation/PhoneNumber.vue";
import inputImage from "./components/inputsValidation/inputImage.vue";
import PriceInput from "./components/inputsValidation/inputPrice.vue";
import memberRoute from "./components/member/memberRoute.vue";
import memberCard from "./components/member/memberCard.vue";
import MemberAnalytics from "./components/member/MemberAnalytics.vue";
import Browser from "./components/member/browser.vue";
import ParticipationsList from "./components/member/ParticipationsList.vue";
import SubscriptionsList from "./components/member/subscriptionsList.vue";
import TransactinsList from "./components/member/transactionsList.vue";
import modalAttachedPointeuses from "./components/member/modalAttachedPointeuses.vue";
import modalEdit from "./components/member/modalEdit.vue";
import pathImage from "./components/member/pathImage.vue";
import memberContract from "./components/member/memberContract.vue";
import userCard from "./components/user/userCard.vue";

/**
 * USERS
 */
import reportingCaisse from "./components/reporting/caisse.vue";
import SubscriptionsSummary from "./components/reporting/SubscriptionsSummary.vue";
import IncomesSummary from "./components/reporting/IncomesSummary.vue";
import ExpensesSummary from "./components/reporting/ExpensesSummary.vue";



import modalAddUser from "./components/user/add.vue";
import modalResetPassword from "./components/user/reset_password.vue";
import modalAffectedToClub from "./components/user/affected_to_club.vue";
import Regulation from "./components/subscription/regulation.vue";

import ChartDoughnut from "./components/chartVue/ChartDoughnut.vue";
import ChartBar from "./components/chartVue/ChartBar.vue";
import ChartLine from "./components/chartVue/ChartLine.vue";
import ChartPolararea from "./components/chartVue/ChartPolararea.vue";
import Chart from "./components/chartVue/chart.vue";


import changeStatus from "./components/modal/transactions/changeStatus.vue";

/**
 * Trainers
 */
import AddTrainer from "./components/modal/trainer/add.vue";
import ReglerTrainer from "./components/modal/trainer/regler.vue";
import TransactionsTrainer from "./components/modal/trainer/transactions.vue";

 
 
/**
 * Assurance Member
 */
 import ModalAssurancePayment from "./components/modal/memberAssurance/ModalAssurancePayment.vue";


/**
 * Incomes
 */
import AddIncome from "./components/modal/income/add.vue";
import AddPaymentService from "./components/modal/income/regler.vue";
import DetailsIncome from "./components/modal/income/details.vue";
import InfoIncome from "./components/modal/income/info.vue";

/**
 * expenses
 */
import AddExpense from "./components/modal/expense/add.vue";
import AddPaymentExpense from "./components/modal/expense/regler.vue";
import DetailsExpense from "./components/modal/expense/details.vue";

/**
 * Announcements
 */
import modalAddAnnouncement from "./components/modal/announcement/add.vue";
import modalAddPromotion from "./components/modal/promotion/add.vue";
import modalAddBilan from "./components/modal/bilan/add.vue";
import listBilans from "./components/modal/bilan/listBilans.vue";

import modalAddSessionBooking from "./components/modal/sessionBooking/add.vue";
import listSessionBookings from "./components/modal/sessionBooking/list.vue";

/*
Transactions
*/
import TransactionsStats from "./components/modal/transactions/stats.vue";
import TransactionsStatsIncomes from "./components/modal/income/stats.vue";
import TransactionsStatsExpenses from "./components/modal/expense/stats.vue";

/*
Subscription
*/
import RevenuByday from "./components/subscription/revenu_byday.vue";

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;
store.commit("auth/loginSuccess", JSON.parse(localStorage.getItem("user")!));
let lang = localStorage.getItem("selectedLang") || "fr";
lang = lang != "" ? lang : "fr";
console.log("lang : " + lang);
const i18n = createI18n({
  locale: lang,
  messages: {
    fr: require("@/i18n/fr.json"),
    en: require("@/i18n/en.json"),
    ar: require("@/i18n/ar.json"),
  },
});
const app = createApp(App);
app.use(router);
app.use(store);
app.use(swal);
app.use(i18n);
app.use(Vue3FormWizard);

app.component("lock-screen", LockScreen);

app.component("element-modal", Modal);
app.component("element-tooltip", Tooltip);
app.component("btn-delete", Delete);
app.component("btn-edit", Edit);
app.component("btn-default", Default);

app.component("month-field", MonthField);
app.component("date-field", DateField);
app.component("daterange-field", DateRangeField);
app.component("timerange-field", TimeRangeField);
app.component("phone-number", PhoneNumber);
app.component("input-image", inputImage);
app.component("price-input", PriceInput);
app.component("member-route", memberRoute);
app.component("modal-browser", Browser);
app.component("participations-list", ParticipationsList);
app.component("subscriptions-list", SubscriptionsList);
app.component("transactions-list", TransactinsList);
app.component("member-card", memberCard);
app.component("member-analytics", MemberAnalytics);
app.component("modal-edit-member", modalEdit);
app.component("ModalAttachPointeusesWithMember", modalAttachedPointeuses);

app.component("user-card", userCard);


app.component("reporting-caisse", reportingCaisse);
app.component("subscriptions-summary", SubscriptionsSummary);
app.component("expenses-summary", ExpensesSummary);
app.component("incomes-summary", IncomesSummary);


 app.component("change-status-payment", changeStatus);

app.component("regulation-subscription", Regulation);

app.component("VueDatePicker", VueDatePicker);

app.component("doughnut-chart", ChartDoughnut);
app.component("bar-chart", ChartBar);
app.component("line-chart", ChartLine);
app.component("polararea-chart", ChartPolararea);
app.component("component-chart", Chart);

app.component("no-permission", NoPermission);
app.component("go-back", goBack);
app.component("not-found", NotFound);
app.component("loader-gif", Loader);
app.component("path-image", pathImage);
app.component("member-contract", memberContract);
;
app.component("element-paginate", Paginate);
app.component("element-boolean-status", booleanStatus);
app.component("element-status", Status);
app.component("element-status-subscription", statusSubscription);
app.component("element-status-payment", statusPayment);
app.component("acces-blocked", accesBlocked);
app.component("element-is-paid", isPaid);
app.component("element-per-page", perPage);
app.component("scanner-qr-code", scannerQrCode);
app.component("capture-photo", capturePhoto);

/**
 * USERS
 */
app.component("modal-add-user", modalAddUser);
app.component("modal-reset-password", modalResetPassword);
app.component("modal-affected-to-club", modalAffectedToClub);

/***
 * Trainers
 */
app.component("modal-add-trainer", AddTrainer);
app.component("modal-regler-trainer", ReglerTrainer);
app.component("modal-transactions-trainer", TransactionsTrainer);

 

/**
 * Assurance member
 */
app.component("modal-assurance-member-payment", ModalAssurancePayment);


/***
 * Incomes
 */
app.component("modal-add-income", AddIncome);
app.component("moda-add-payment-service", AddPaymentService);
app.component("modal-details-income", DetailsIncome);
app.component("informations-income", InfoIncome);

/***
 * expense
 */
app.component("modal-add-expense", AddExpense);
app.component("modal-add-payment-expense", AddPaymentExpense);
app.component("modal-details-expense", DetailsExpense);

/**
 * Announcement
 */
app.component("modal-add-announcement", modalAddAnnouncement);
app.component("modal-add-promotion", modalAddPromotion);
app.component("modal-add-bilan", modalAddBilan);
app.component("modal-add-session-booking", modalAddSessionBooking);
app.component("list-bilans", listBilans);
app.component("list-bookings", listSessionBookings);
/**
 * Transactions
 */
app.component("modal-reporting-cashflow-stats", TransactionsStats);
app.component("modal-reporting-cashflow-stats-incomes", TransactionsStatsIncomes);
app.component("modal-reporting-cashflow-stats-expenses", TransactionsStatsExpenses);

/**
 * Subscription
 */
app.component("modal-revenu-byday", RevenuByday);

app.component("font-awesome-icon", FontAwesomeIcon);

// Check localStorage and import the appropriate style
const style = localStorage.getItem("style") ?? "ltr";
import "@/sass/styles/theme_ltr/style.scss";
document.body.classList.add(style?.toString());
document.documentElement.setAttribute("dir", style?.toString());

// if (style === 'ltr') {
//   import('@/sass/styles/theme_ltr/style.scss').then(() => {
//     document.body.classList.add('ltr');
//   });
// } else if (style === 'rtl') {
//   import('@/sass/styles/theme_rtl/style.scss').then(() => {
//     document.body.classList.add('rtl');
//   });
// }

app.mount("#app");
